import React, { Fragment, PureComponent } from 'react';
import dynamic from 'next/dynamic';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Carousel from 'components/Carousel/Carousel';

import PlayIcon from './components/PlayIcon/PlayIcon';
import { NubankerContentLink } from './styles/NubankerContentLink';
import { PlayVideoContent } from './styles/PlayVideoContent';

const ResponsiveImages = dynamic(import('components/ResponsiveImage/ResponsiveImages'), { ssr: false });

const nubankers = [
  {
    role: 'Como é ser Technical Product Manager no Nubank?',
    url: 'https://www.youtube.com/watch?v=f8PNBTEQCDs&t=61s',
    image: 'nubanker-tpm/nubanker-tpm.jpg',
  },
  {
    role: 'Como é ser Product Manager no Nubank?',
    url: 'https://www.youtube.com/watch?v=cy1YwS57wa8&t=32s',
    image: 'nubanker-pm/nubanker-pm.jpg',
  },
  {
    role: 'Como é trabalhar com engenharia de software no Nubank?',
    url: 'https://www.youtube.com/watch?v=tOzvNTzRMP8&t=26s',
    image: 'nubanker-eng/nubanker-eng.jpg',
  },
  {
    role: 'Como é ser Xpeer no Nubank?',
    url: 'https://www.youtube.com/watch?v=w9GbIfolvUs&t=15s',
    image: 'nubanker-xpeer/nubanker-xpeer.jpg',
  },
  {
    role: 'Como é ser data scientist no Nubank?',
    url: 'https://www.youtube.com/watch?v=umq9kCJFavw',
    image: 'nubanker-ds/nubanker-ds.jpg',
  },
  {
    role: 'Como é ser arquiteto de negócios no Nubank?',
    url: 'https://www.youtube.com/watch?v=432fzz-SQ14',
    image: 'nubanker-bizarch/nubanker-bizarch.jpg',
  },
];

class SectionNubankers extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentNubankerStep: 1,
    };
  }

  handleChangeCarouselNubankerStep = step => {
    this.setState(() => ({
      currentNubankerStep: step,
    }));
  };

  render() {
    const { currentNubankerStep } = this.state;

    return (
      <Section>
        <Block>
          <Typography
            variant="title"
            gutterBottom={1.5}
            intlKey="CAREERS.NUBANKERS.TITLE"
          />
          <Typography
            variant="paragraph2"
            intlKey="CAREERS.NUBANKERS.DESCRIPTION"
          />
        </Block>
        <Block textAlign="center">
          <Carousel
            currentStep={currentNubankerStep}
            onStepChanged={this.handleChangeCarouselNubankerStep}
          >
            {nubankers.map(nubanker => (
              <Fragment key={nubanker.role}>
                <Typography
                  variant="subtitle"
                  color="black"
                  colorVariant="default"
                  gutterBottom={1.5}
                >
                  {nubanker.role}
                </Typography>
                <NubankerContentLink href={nubanker.url} target="_blank" noStyle>
                  <PlayVideoContent>
                    <PlayIcon />
                  </PlayVideoContent>
                  <ResponsiveImages
                    alt={nubanker.role}
                    loading="lazy"
                    fileName={nubanker.image}
                    width="100%"
                  />
                </NubankerContentLink>
              </Fragment>
            ))}
          </Carousel>
        </Block>
      </Section>
    );
  }
}

export default SectionNubankers;
